<template>
  <div
    class=" uk-margin-top uk-flex block block--faint block--button block--expand"
    @click.prevent="openWindow"
  >
    <slot>
      <span class="uk-icon-ticket uk-margin-small-right" /> Log in to your Institute account to view your entries
    </slot>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Mixins, Watch } from "vue-property-decorator";
import FormStep from "./FormStep";

function calculateCenter(w: number, h: number): {left: number, top: number} {
  // Fixes dual-screen position                         Most browsers      Firefox
  let dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : (screen as any).left;
  let dualScreenTop = window.screenTop != undefined ? window.screenTop : (screen as any).top;
  //
  let width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
  let height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
  //
  const left = ((width / 2) - (w / 2)) + dualScreenLeft;
  const top = ((height / 2) - (h / 2)) + dualScreenTop;

  return {left, top};
}

@Component
export default class PopupAuthentication extends Mixins(FormStep) {

  @Prop({default: false}) open!: boolean;

  popup: Window | null = null;

  mounted(): void {
    if (/*!this.popup &&*/ this.open) {
      this.createWindow();
    }
  }

  focusWindow(): void {
    this.popup?.focus();
  }

  createWindow(): void {
    const w = 600;
    const h = 440;
    const pos = calculateCenter(w, h);

    const features = `modal=yes,toolbar=no,menubar=no,scrollbars=no,width=${w},height=${h},top=${pos.top},left=${pos.left}`;
    this.popup = window.open(window.location.origin + "/view/events/authenticate?iframe", "_blank", features);

    const closeCheck = setInterval(() => {
      if (this.popup?.closed) {
        clearInterval(closeCheck);
        this.popup = null;

        this.$store.dispatch('context/fetchUser');
      }
    }, 300);
  }

  openWindow(): void {
    // if (!this.popup) {
      this.createWindow();
    // }
    this.focusWindow();
  }

  @Watch('userAuthenticated')
  handleUserAuthentication(nv: boolean, ov: boolean): void {
    if (nv) {
      this.$emit('input', this.user.data.id);
    }
    this.$emit('valid', nv);
  }
}
</script>

<style scoped>

</style>
